import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('put', `/api/courses/${id}/unsync-student-course/`, payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/unsyncStudentFromCourse.js